module.exports = __webpack_public_path__ + "static/media/email-box.70e0d08c.svg";